import {Link} from 'react-router-dom'
import styled from '@emotion/styled'
import {css} from '@emotion/core'

import {mq} from '../../../../utils/breakpoints'

const headerElementStyles = ({theme}) => css`
  background-color: ${theme.colors.headerBgPrimary};
  padding: ${theme.layout.spacing.s300}px 0;
  box-shadow: ${theme.shadows.action};
  position: relative;
  z-index: 4;
`

export const HeaderElement = styled('header')(headerElementStyles)

export const LogoWrapper = styled('div')`
  text-align: center;

  ${mq.desktopSm(`
    text-align: left;
  `)}
`

const mirror = () => css`
  /* @mirror */
`

export const ButtonElement = styled('button')`
  display: inline-flex;
  background: none;
  border: none;
  outline: none;
`

const backButtonBaseStyles = ({theme}) => css`
  margin-left: -${theme.layout.spacing.s400}px;
  padding: ${theme.layout.spacing.s400}px;
  color: ${theme.colors.backButtonColorPrimary};
`

export const BackButtonElement = styled(ButtonElement)(
  backButtonBaseStyles,
  mirror
)

const withBrandStyles = ({theme, brand}) => {
  if (brand === 'findhotel') {
    return css`
      height: ${theme.layout.spacing.s600}px;
      margin: ${theme.layout.spacing.s400}px 0;
    `
  }

  return css`
    height: ${theme.layout.spacing.s700}px;
    margin: ${theme.layout.spacing.s300}px 0;
  `
}

export const LogoLinkElement = styled(Link)`
  display: inline-block;

  ${withBrandStyles};
`

export const LogoElement = styled('div')`
  display: inline-block;

  ${withBrandStyles};
`

export const LogoAnchorElement = styled('a')`
  display: inline-block;

  ${withBrandStyles};
`

export const HeaderControlsWrapper = styled('div')(
  ({theme}) => css`
    text-align: right;
    position: relative;
    z-index: 11;
    margin: ${theme.layout.spacing.s200}px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  `
)

export const UserControlWrapper = styled('div')(
  () => css`
    display: inline-block;
    vertical-align: top;
    margin-left: -1px;
    position: relative;
  `
)
